import React from "react";
import styled from "styled-components";
import { FaArrowRightLong} from "react-icons/fa6";
import { FaCheckDouble } from "react-icons/fa6";
import { dataSkills } from "../data/dataSkills";
import { dataLibs, dataAdditional, dataTechLanguages } from "../data/dataTech";


function ExperienceSmall() {
  const [activeIndex, setActiveIndex] = React.useState(1);

  function handleClick(index) {
    setActiveIndex(activeIndex === index ? -1 : index);
  }

  return (
    <Wrapper className="experience__container_small">
      <div className="container container__1" onClick={() => handleClick(1)}>
        <p className="heading__1">About me</p>
        <div
          className={`content content__1 ${
            activeIndex === 1 ? "active" : "none"
          }`}
        >
          <p>
            My name is Mihaela Diaconu. I’m a freelance full-stack web & mobile
            developer and designer based in Iasi, Romania. My expertise is in full
            applications development and design from start to finish. I love to
            create smart and beautiful user interfaces and to imagine new ways
            of building things or solving problems.
          </p>
          <p>
            Despite my academic background as a university professor with a PhD
            in financial management and extensive experience in the field of
            finance, I've developed a profound passion for development and
            associated technologies. I have been consolidating my knowledge in
            this field by being involved in countless courses and personal projects,
            as well as in projects for family, acquaintances and clients.
          </p>
          <p>
            My development roots are in VanillaJs & React. Then, I’ve
            started to broaden my knowledge of the Node.js ecosystem, which I
            fell in love with & have been primarily using it in React
            applications. I also love working with Nex.js for its powerful
            combination of server-side rendering, static site generation, and
            seamless integration with React.
          </p>
          <p>
            Whether you're a business owner looking to get started on a mobile app or
            web development project with a freelance developer, a developer
            looking to collaborate on something cool, or just wanting to say hi,
            shoot me a message and let's work together.
          </p>
        </div>
      </div>
      <div className="container container__2" onClick={() => handleClick(2)}>
        <p className="heading__2">Tech Stack</p>
        <div
          className={`content content__2 ${
            activeIndex === 2 ? "active" : "none"
          }`}
        >
          <p>
            Here is a selection of relevant technologies that I have experience
            width
          </p>
          <div className="details">
            <ul>
              <div className="lang__title">
              <h4>LANGUAGES</h4>
              <div className="hr"></div>
              </div>
              {dataTechLanguages.map((lg) => {
                return (
                  <li key={lg.id}>
                    <FaArrowRightLong className="icon" />
                    {lg.tech}
                  </li>
                );
              })}
            </ul>
            <ul>
              <div className="lang__title">
              <h4>FRAMEWORKS & LIBS</h4>
              <div className="hr"></div>
              </div>
              {dataLibs.map((lg) => {
                return (
                  <li key={lg.id}>
                    <FaArrowRightLong className="icon" />
                    {lg.tech}
                  </li>
                );
              })}
            </ul>
            <ul>
              <div className="lang__title">
              <h4>TOOLS & DEVOPS</h4>
              <div className="hr"></div>
              </div>
              {dataAdditional.map((lg) => {
                return (
                  <li key={lg.id}>
                    <FaArrowRightLong className="icon" />
                    {lg.tech}
                  </li>
                );
              })}
            </ul>
          </div>
        </div>
      </div>

      <div className="container container__3" onClick={() => handleClick(3)}>
        <p className="heading__3">Core Skills</p>
        <div
          className={`content content__3 ${
            activeIndex === 3 ? "active" : "none"
          }`}
        >
          <ul>
            {dataSkills.map((skill) => {
              return (
                <li key={skill.id}>
                  <FaCheckDouble className="icon" />
                  {skill.skill}
                </li>
              );
            })}
          </ul>
        </div>
      </div>
    </Wrapper>
  );
}

const Wrapper = styled.section`
  background: var(--clr-navy-7);
  margin-top: 3rem;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: auto;
  border-left: 2px solid #f52c57;

  .container {
    height: 100%;
    margin-bottom: 3rem;
  }

  .container p {
    padding-left: 2rem;
    padding-bottom: 1.75rem;
    font-weight: bold;
    cursor: pointer;
  }

  .active {
    border-bottom: 2px solid #f52c57;
    padding-left: 1rem;
  }

  .none {
    display: none;
  }

  p {
    color: var(--clr-grey-8);
  }

  //about - content__1
  .content__1 p {
    font-weight: normal;
    font-size: 1rem;
    text-align: justify;
    padding-left: 0;
  }

  .icon {
    display: block;
    margin-right: 0.25rem;
    color: #f52c57;
  }

  /* tech stack - content__2 */

  .content__2 p {
    text-align: center;
    padding-bottom: 1.5rem;
    font-size: 1.1rem;
  }

  .content__2 .details {
    display: flex;
    width: 100%;
    justify-content: space-evenly;
    flex-wrap: wrap;
    /* background: var(--clr-millenium-blue);
    box-shadow: 0 0 1px var(--clr-grey-6);
    border-radius: 0.2rem; */
  }

  .details ul {
    width: max-content;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  .details ul h4 {
    padding-bottom: 0.5rem;
    padding-top: 0.2rem;
  }

  .lang__title {
    margin-bottom: 0.8rem;
  }

  .details ul .hr {
    width: 25%;
    height: 1.5px;
    background: var(--clr-grey-4);
    margin-bottom: 0.5rem;
    margin-left: 0;
  }

  .details ul li {
    margin-bottom: 0.8rem;
    display: flex;
    align-items: center;
    font-size: 1rem;
  }

  //core skills
  .content__3 {
    margin-bottom: -50px;
  }

  .content__3 ul {
    width: max-content;
    margin: 0 auto;
  }

  .content__3 ul li {
    margin-bottom: 0.8rem;
    display: flex;
    align-items: center;
    font-size: 1rem;
  }

  @media only screen and (max-width: 773px) {
    .details ul {
      margin-bottom: 1.75rem;
    }
    .content__3 ul {
      width: 100%;
    }
  }

  @media only screen and (max-width: 720px) {
    .details {
      display: grid;
      grid-template-columns: 1fr;
      grid-template-rows: 3fr;
    }
    .details ul {
      width: 350px;
    }
    .details ul .hr {
      margin: 0 auto;
      margin-left: unset;
    }
  }

  @media only screen and (max-width: 660px) {
    .content__1 p {
      font-size: 1rem;
    }

    .content__3 ul li {
      font-size: 1rem;
    }
  }
`;

export default ExperienceSmall;
